document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("usp-slider")) {
    customElements.define(
      "usp-slider",
      class UspSlider extends HTMLElement {
        constructor() {
          super();
          this.sliderRef = this.querySelector("[data-slider]");
          this.nextRef = this.querySelector('[data-navigation="next"]') || null;
          this.previousRef =
            this.querySelector('[data-navigation="previous"]') || null;
          this.productsToShow = this.dataset.productsToShow || 4;
          this.initSwiper = this.initSwiper.bind(this);
          this.childElements = this.querySelectorAll(".swiper-slide");
        }

        connectedCallback() {
          if (!this.sliderRef) {
            return;
          }
          if (
            this.childElements.length < 4 ||
            this.childElements.length < this.productsToShow
          ) {
            return;
          }
          this.initSwiper();
        }

        initSwiper() {
          const slider = new Swiper(this.sliderRef, {
            spaceBetween: 10,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            breakpoints: {
              0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
              },
              768: {
                slidesPerView: 2.5,
              },
              1280: {
                slidesPerView: this.productsToShow,
                slidesPerGroup: 4,
              },
            },
          });
        }
      }
    );
  }
});
